var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed inset-0 z-20 flex items-stretch justify-end w-full h-full bg-black cursor-pointer bg-opacity-80",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.$emit('close')}}},[_c('transition',{attrs:{"name":"slide-in-left","appear":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }